<div class="container pb-4 pt-4 ">
  <app-breadcrumb currentRouteName="Prestations planifiées"></app-breadcrumb>
  <h1 class="pt-4">Prestations planifiées</h1>
  <div class="row">
    <div class="col-md-5 d-none d-sm-block">
      <app-search-bar (search)="search = $event"></app-search-bar>
      <div class="alert alert-info">
        <fa-icon icon="info-circle"></fa-icon>
        Seules les prestations planifiées les 4 prochains mois sont affichées sur cette page.
      </div>
      <div class="infos-grid mb-4">
        @for (meeting of meetings | search:search | sort:'dateStart'; track meeting; let index = $index) {
          <div
            [class.separator]="index > 0" [class.over]="overMeeting !== undefined && overMeeting.id === meeting.id"
            class="p-3" (mouseleave)="overMeeting = undefined" (mouseover)="overMeeting = meeting">
            <h2>{{ meeting.name }}</h2>
            <p><strong>Produit :</strong> {{ meeting.product.name }}</p>
            <p><strong>Intervenant :</strong> {{ meeting.speaker }}</p>
            <p><strong>Date de début :</strong> {{ meeting.dateStart | date:'dd MMMM y à HH:mm' }}</p>
            <p><strong>Lieu :</strong> {{ meeting.place | place }}</p>
          </div>
        }
      </div>
      @if (search && (meetings | search:search).length === 0) {
        <div>
          <p class="text-light-grey">Aucun rendez-vous ne correspond à la recherche.</p>
        </div>
      }
    </div>
    <div class="col-sm-auto col-md-7 pt-sm-0 pt-4 d-flex align-content-start justify-content-around flex-wrap calendars">
      @for (d of dates; track d) {
        <app-prestation-calendar
          class="pe-md-4 pb-4 flex-sm-grow-0 flex-grow-1"
          [year]="d.getFullYear()"
          [month]="d.getMonth()"
          [meetings]="meetings"
          [(over)]="overMeeting"
        (showMeeting)="view($event)"></app-prestation-calendar>
      }
    </div>
  </div>
</div>


<ng-template #viewMeeting let-modal>
  <form action="javascript:void(0)">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-password-title">
        {{ meeting.name }}
      </h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
      </button>
    </div>
    <div class="modal-body container bg-white">
      <div>
        <p class="fw-bold">Produit :</p>
        <p>{{ meeting.product.name }}</p>
        <p class="fw-bold">Intervenant :</p>
        <p>{{ meeting.speaker }}</p>
        <p class="fw-bold">Date de début :</p>
        <p>{{ meeting.dateStart | date:'dd MMMM y à HH:mm' }}</p>
        <p class="fw-bold">Lieu</p>
        <p>{{ meeting.place | place }}</p>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="modal.close()">Fermer</button>
    </div>
  </form>
</ng-template>



